import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonEffect } from './common.effects';
import { commonReducer } from './common.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('COMMON', commonReducer), EffectsModule.forFeature([CommonEffect])],
  exports: [],
})
export class CommonStoreModule {}
